import { TradReelSet } from '@1x2network/reel_set'
import { CustomSymbol } from '../CustomSymbol'
import { SymbolModel } from '../model/SymbolModel'
import gsap from 'gsap'
import { gsapSpineWrapper } from '@1x2network/tweens'
import { Specification } from '@1x2network/pixi_assets'
import { TradReelSetSpecProvidedPool } from '@1x2network/reel_set/lib/prefabs/traditional/TradReelSet'
import { valueIds } from '../constants/valueIds'
import { IdleHandler } from '@1x2network/idle_detection'

export class IdleSymbolAnimation {
    private handler: IdleHandler
    private reelSet: TradReelSet<CustomSymbol, SymbolModel>
    private timeline?: gsap.core.Timeline
    private symbolSize: { width: number; height: number }

    constructor(handler: IdleHandler, reelSet: TradReelSet<CustomSymbol, SymbolModel>) {
        this.handler = handler
        this.reelSet = reelSet
        this.handler.onIdleTick.connect(this.startAnimation.bind(this))
        this.handler.onIdleEnd.connect(this.stopAnimation.bind(this))
        const reelSetSpec = Specification.get('reelSet') as TradReelSetSpecProvidedPool<never>
        this.symbolSize = { width: reelSetSpec.reel.symbolWidth, height: reelSetSpec.reel.symbolHeight }
    }

    private startAnimation() {
        const delay = 0.5
        const symbols = this.sortSymbolsByDiagonals(this.getSymbols())
        const timeline = gsap.timeline()
        symbols.forEach(async (line, index) => {
            line.map((symbol) => {
                const tl = gsap
                    .timeline()
                    .add(gsapSpineWrapper(symbol.spine!, 0, symbol.animations.land))
                    .call(() => {
                        symbol.playIdle()
                    })
                timeline.add(tl, delay * index)
            })
        })
        this.timeline = timeline
    }

    private sortSymbolsByDiagonals(symbols: CustomSymbol[]): CustomSymbol[][] {
        const diagonalMap = new Map<number, CustomSymbol[]>()
        // generate a map grouping symbols on the same diagonal
        for (const symbol of symbols) {
            // width and height might be different, normalise to position
            const diagonalIndex = symbol.x / this.symbolSize.width + symbol.y / this.symbolSize.height
            if (!diagonalMap.has(diagonalIndex)) {
                diagonalMap.set(diagonalIndex, [])
            }
            diagonalMap.get(diagonalIndex)?.push(symbol)
        }

        // Convert map to sorted array of diagonals
        return [...diagonalMap.entries()]
            .sort((a, b) => a[0] - b[0]) // sort by diagonal index
            .map(
                ([_, group]) => group.sort((a, b) => a.y - b.y), // optional: sort each diagonal top-to-bottom
            )
    }

    private getSymbols() {
        return valueIds.flatMap((id) => this.reelSet.fetcher.getSymbolsById(id))
    }

    private stopAnimation() {
        this.timeline?.kill()
        this.getSymbols().forEach((symbol) => {
            symbol.blurred = false
        })
    }
}
